import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const OmbudsmanContactList = styled.ul`
  li {
    margin-bottom: ${themeSpace(1)};
  }
`;

OmbudsmanContactList.displayName = 'OmbudsmanContactList';
